import { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Loader from "../../shared/loader";
import confirm from "../../shared/modal/confirm";
import {
  fetchUser,
  disableUser,
  updateUser,
  fetchPricingPlans,
  cancelUpload,
  deleteUser,
  clearRedirect
} from "./ducks/actions";
import Form from "./form";

function User(props) {
  const {
    fetchUser,
    loading,
    errors,
    user,
    disableUser,
    updateUser,
    fetchPricingPlans,
    pricingPlans,
    cancelUpload,
    deleteUser,
    redirect,
    clearRedirect
  } = props;

  const userId = props.match.params.userId;

  const invalidIds = ["countries", "dates", "order", "storyboard"];


  useEffect(() => {
    fetchPricingPlans();
  }, []);

  useEffect(() => {
    if (invalidIds.indexOf(userId) === -1) {
      fetchUser(userId);
    }
  }, [userId]);

  useEffect(() => {
    return () => {
      if (redirect) {
        clearRedirect();
      }
    };
  }, [redirect]);

  if (invalidIds.indexOf(userId) > -1) {
    return null;
  }

  if (loading) {
    return <Loader />;
  }

  if (redirect) {
    return <Redirect to={redirect.to} />;
  }

  const onDisableUser = (e) => {
    e.preventDefault();
    confirm(() => disableUser(userId), null, "Are you sure you want to disable user?", "Disable User");
  };

  const onDeleteUser = (e) => {
    e.preventDefault();
    confirm(() => deleteUser(userId), null, "Are you sure you want to delete user?", "Delete User");
  };

  function onUpdateDetails(user) {
    if (!user.maximumFilms) {
      user.maximumFilms = null;
    }

    updateUser(user);
  }

  const onCancelUpload = (e) => {
    e.preventDefault();
    cancelUpload(user)
  }

  return (
    <div className="blade-content wideaf">
      <Form
        onSubmit={onUpdateDetails}
        errors={errors}
        loading={false}
        user={user}
        initialValues={user}
        disableUser={onDisableUser}
        deleteUser={onDeleteUser}
        pricingPlans={pricingPlans}
        cancelUpload={onCancelUpload}
      />
    </div>
  );
}

function mapStateToProps(state) {
  const { adminState } = state;
  return {
    user: adminState.adminUserState.user,
    pricingPlans: adminState.adminUserState.pricingPlans,
    errors: adminState.adminUserState.errors,
    loading: adminState.adminUserState.loading,
    redirect: adminState.adminUserState.redirect
  };
}

export default connect(mapStateToProps, {
  fetchUser,
  disableUser,
  updateUser,
  fetchPricingPlans,
  cancelUpload,
  deleteUser,
  clearRedirect
})(User);
